import { CurrencyModel } from '@/interface';
import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';

/** Строка справочника номиналов: какой номинал разрешён по какой валюте */
export interface CurrencyDenominationRequest {
    /** Буквенный код валюты, как в справочнике: «KZT», «USD» */
    currencyCode: string;
    /** Сам номинал купюры или монеты; допускаются дробные (0.5) */
    denomination: number;
}

export class CurrencyController {
    /**
     * Добавляет валюту в отделение сразу, без акцепта. Курсы из rates заводятся
     * вместе с ней; по коду GOLD* бэк заводит сразу все слитки GOLD1…GOLD100.
     * Ошибку бэк отдаёт со статусом 200 объектом исключения, поэтому успех —
     * только ответ с currencyId. Не идемпотентна: повтор заведёт дубль валюты.
     * После добавления бэк сам рассылает отделения по сокету ReceiveRates.
     */
    async addCurrency(currency: CurrencyModel): Promise<CurrencyModel | { message?: string }> {
        return await server.post('/Currency/addCurrency', currency, {
            baseURL: BACKEND_URL
        });
    }

    async updateCurrency(currency: CurrencyModel) {
        return await server.patch('/Currency/updateCurrency', currency, {
            baseURL: BACKEND_URL
        });
    }

    async deleteCurrency(currencyId: string | number) {
        return await server.delete(`/Currency/removeCurrency/${currencyId}`, {
            baseURL: BACKEND_URL
        });
    }

    async updateCurrencyMany(currencies: Partial<CurrencyModel>[]): Promise<CurrencyModel[]> {
        return await server.post('/Currency/updateCurrencyMany', currencies, {
            baseURL: BACKEND_URL
        });
    }

    /**
     * Добавляет номиналы в справочник валют. Тело — массив, за один вызов можно
     * завести сразу несколько номиналов и по разным валютам. Тела ответа нет:
     * актуальный список номиналов после этого нужно перечитать.
     * Денег не двигает, но и не идемпотентна — повтор заведёт дубль строки.
     * На уже заведённый номинал бэк отвечает ошибкой «уже есть в справочнике». Общий снекбар
     * клиента для этой ручки выключен: ошибку показывает вызывающий, и только если это
     * не такой отказ.
     */
    async addCurrencyDenominations(denominations: CurrencyDenominationRequest[]): Promise<void> {
        return await server.post('/CurrencyDenomination', denominations, {
            baseURL: BACKEND_URL,
            silentError: true,
        });
    }

    /** Удаляет номинал справочника по id строки (не по значению номинала). Тела ответа нет */
    async deleteCurrencyDenomination(id: number): Promise<void> {
        return await server.delete(`/CurrencyDenomination/${id}`, {
            baseURL: BACKEND_URL
        });
    }
}
